import React, { useEffect, useState } from "react";
import { SubmitHandler, useForm } from "react-hook-form";
import { useAppDispatch, useAppSelector } from "../../app/hooks";
import {
  getEditPurchaseItem,
  getIsPurchaseItemModalOpen,
  togglePurchaseItemModal,
} from "../../features/purchaseItems/purchaseItemsSlice";

import styles from "./PurchaseItemFormModal.module.scss";
import { IPurchaseItemFormInput } from "../../types/purchaseItem";

type Props = {
  handleSavePurchaseItem: (data: IPurchaseItemFormInput) => void;
};

const PurchaseItemFormModal = ({ handleSavePurchaseItem }: Props) => {
  const dispatch = useAppDispatch();
  const editPurchaseItem = useAppSelector(getEditPurchaseItem);
  const isPurchaseItemModalOpen = useAppSelector(getIsPurchaseItemModalOpen);

  const [isLoading, setIsLoading] = useState<boolean>(false);

  const {
    handleSubmit,
    register,
    reset,
    formState: { errors },
  } = useForm<IPurchaseItemFormInput>({
    defaultValues: { name: "", description: "" },
  });

  const handleOnSubmit: SubmitHandler<IPurchaseItemFormInput> = async (
    data: any
  ) => {
    setIsLoading(true);
    await handleSavePurchaseItem(data);
    handleCloseFormModal();
    setIsLoading(false);
  };

  const handleCloseFormModal = () => {
    reset();
    dispatch(togglePurchaseItemModal(false));
  };

  useEffect(() => {
    if (editPurchaseItem && editPurchaseItem.id) {
      reset({
        name: editPurchaseItem.name,
        description: editPurchaseItem.description,
      });
    } else {
      reset({ name: "", description: "" });
    }
  }, [editPurchaseItem, isPurchaseItemModalOpen]);

  return (
    <>
      {isPurchaseItemModalOpen === true && (
        <div className={styles.PurchaseItemFormModal}>
          <div className="relative h-[100vh] w-[100vw] overflow-y-scroll lg:overflow-auto top-0 lg:top-10 lg:mx-auto p-5 border lg:w-96 lg:h-fit shadow-lg lg:rounded-md bg-white">
            <div className="mt-3">
              <h3 className="text-2xl text-center font-bold leading-6 text-primary-1">
                ખરીદી આઈટમ ની માહિતી
              </h3>
              <div className="mt-2 py-3">
                <form onSubmit={handleSubmit(handleOnSubmit)}>
                  <div className="grid gap-4">
                    <div className="mt-4">
                      <label className="text-primary-1 font-bold">
                        નામ :
                      </label>
                      <div className="bg-gradient-to-r from-primary-1 to-primary-2 h-16 lg:h-14 w-full relative rounded">
                        <input
                          className="text-primary-1 focus:outline-none px-3 py-1 font-semibold text-xl placeholder:text-primary-2 absolute top-[2px] left-[2px] w-[calc(100%-4px)] h-[calc(100%-4px)] rounded"
                          type="text"
                          placeholder="ખરીદી આઈટમનુ નામ દાખલ કરો"
                          {...register("name", { required: true })}
                        />
                      </div>
                      {errors.name && errors.name.type === "required" && (
                        <span className="text-red-500">
                          ખરીદી આઈટમનુ નામ દાખલ કરો
                        </span>
                      )}
                    </div>

                    <div>
                      <label className="text-primary-1 font-bold">
                        ડિસ્ક્રિપ્શન :
                      </label>
                      <div className="bg-gradient-to-r from-primary-1 to-primary-2 h-28 w-full relative rounded">
                        <textarea
                          rows={5}
                          className="text-primary-1 focus:outline-none px-3 py-1 font-semibold text-xl placeholder:text-primary-2 absolute top-[2px] left-[2px] w-[calc(100%-4px)] h-[calc(100%-4px)] rounded"
                          placeholder="ખરીદી આઈટમનુ ડિસ્ક્રિપ્શન દાખલ કરો"
                          {...register("description", { required: false })}
                        />
                      </div>
                      {errors.description &&
                        errors.description.type === "required" && (
                          <span className="text-red-500">
                            ખરીદી આઈટમનુ ડિસ્ક્રિપ્શન દાખલ કરો
                          </span>
                        )}
                    </div>

                    <div className="mt-3 text-center">
                      <button
                        className="mx-auto shadow disabled:opacity-50 rounded-3xl text-3xl lg:text-xl text-white bg-gradient-to-r from-primary-1 to-primary-2 font-bold px-10 py-2"
                        type="submit"
                        disabled={isLoading}
                      >
                        {isLoading ? "રાહ જુઓ..." : "આગળ વધો"}
                      </button>
                    </div>

                    <div className="mt-1 text-center">
                      <button
                        className="mx-auto shadow disabled:opacity-50 rounded-3xl text-3xl lg:text-xl text-white bg-gradient-to-r from-primary-1 to-primary-2 font-bold px-10 py-2"
                        type="button"
                        onClick={handleCloseFormModal}
                        disabled={isLoading}
                      >
                        બંધ કરો
                      </button>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default PurchaseItemFormModal;
